import { esc } from "./utils.js";

/**
 * The "..." menu a detail page offers its owner: Edit, Delete, and
 * whatever else that page allows.
 *
 * Every detail page had its own copy of this markup, and they had
 * drifted — the photo page ended up with two floating round buttons
 * instead of a menu, and only some of the others gave the toggle an
 * accessible name. One function so a change lands everywhere.
 *
 * Items are rendered in the order given. Falsy entries are dropped, so a
 * caller can inline a permission check:
 *
 *   manageMenuHtml([
 *     canEdit && { id: "edit-post-btn", icon: "bi-pencil", label: "Edit" },
 *     { id: "delete-post-btn", icon: "bi-trash", label: "Delete", danger: true },
 *   ], { label: "Manage this post" })
 *
 * Returns "" when nothing is left, so an empty menu never renders.
 */
export function manageMenuHtml(items, { label = "Manage" } = {}) {
  const usable = (items || []).filter(Boolean);
  if (!usable.length) return "";
  return `
    <div class="dropdown">
      <button class="btn btn-sm btn-outline-secondary" type="button"
              data-bs-toggle="dropdown" aria-expanded="false" aria-label="${esc(label)}">
        <i class="bi bi-three-dots"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end">
        ${usable
          .map(
            (item) => `<button class="dropdown-item${item.danger ? " text-danger" : ""}"
                               type="button" id="${esc(item.id)}">
              <i class="bi ${esc(item.icon)} me-2"></i>${esc(item.label)}
            </button>`
          )
          .join("")}
      </div>
    </div>`;
}
